import { get } from "lodash";
import format from "string-template";

export const areRequiredProofsComplete = (proofPercentage) =>
  proofPercentage === 100;

export const isAssiaSendToManagementDisabled = ({
  proofPercentage,
  loading,
  canSendToManagement,
  isLastSendSuccess,
  isLastSendPending,
  lastSentToManagement,
}) =>
  Boolean(loading) ||
  !canSendToManagement ||
  Boolean(isLastSendSuccess) ||
  Boolean(isLastSendPending) ||
  Boolean(lastSentToManagement) ||
  !areRequiredProofsComplete(proofPercentage);

const ASSIA_SUDE_URL =
  "https://starweb.cimut.services/meslCIP/SUDEindex.htm?RECLAM_ID={sudeId}&CTX_APPELANT=00&Organisme=9931";

export const getAssiaSudeId = (subscription) => {
  const assia = get(subscription, "additionalInfo.assia") || {};
  if (assia.sudeId) return String(assia.sudeId);
  const match = /(\d+)/.exec(get(assia, "sudeResponse.description") || "");
  return match ? match[1] : null;
};

export const getAssiaSudeUrl = (subscription) => {
  const sudeId = getAssiaSudeId(subscription);
  return sudeId ? format(ASSIA_SUDE_URL, { sudeId }) : null;
};
